import type { Control } from "react-hook-form";
import type { Person } from "../../../../utils/backend-types";
import { type applyHighlightingToObjectFormFieldData } from "../../../../utils/react-hook-form/applyHighlightingToObjectFormFieldData";
import { FormFieldController } from "../../../BuildingBlocks/Forms/Controllers/FormFieldController";
import { FormSection } from "../../../BuildingBlocks/Forms/FormSection/FormSection";
import { FormFieldInfoText } from "../../../BuildingBlocks/Forms/MantineFormFields/FormFieldInfoText/FormFieldInfoText";
import { type PERSON_FORM_FIELD_DATA } from "../PersonForm.constants";

interface EditFieldsProps {
  control: Control<Person>;
  formFieldData: ReturnType<
    typeof applyHighlightingToObjectFormFieldData<
      Person,
      typeof PERSON_FORM_FIELD_DATA
    >
  >["formFieldData"];
}

function GeneralPartnerFields({ control, formFieldData }: EditFieldsProps) {
  return (
    <FormSection label="Persönlich haftende Gesellschafter" mt="xl">
      <FormFieldInfoText infoText="Da der persönlich haftende Gesellschafter Ihrer KG, OHG oder KGaA ein anderes Unternehmen ist, ergänzen Sie bitte noch die folgenden Informationen:" />
      <FormFieldController
        control={control}
        data={formFieldData.generalPartnerName}
      />
      <FormFieldController
        control={control}
        data={formFieldData.generalPartnerCity}
      />
      <FormFieldController
        control={control}
        data={formFieldData.generalPartnerCourt}
      />
      <FormFieldController
        control={control}
        data={formFieldData.generalPartnerRegisterNumber}
      />
      <FormFieldController
        control={control}
        data={formFieldData.generalPartnerCeo}
      />
    </FormSection>
  );
}

export { GeneralPartnerFields };
